<section class="dialog-header">
  <h1 mat-dialog-title>{{ data.title || file()?.name }}</h1>
  <button
    mat-icon-button
    [attr.aria-label]="'documentEditor.close' | translate"
    (click)="close()"
  >
    <mat-icon>close</mat-icon>
  </button>
</section>

<div mat-dialog-content>
  @if (file(); as file) {
    <app-docx-editor [file]="file" (edited)="onEdited($event)"></app-docx-editor>
  } @else {
    <app-docx-skeleton></app-docx-skeleton>
  }
</div>

<mat-divider></mat-divider>

<mat-dialog-actions>
  <button mat-button (click)="close()">{{ 'documentEditor.close' | translate }}</button>
  <button mat-flat-button [disabled]="!file()" [class.disabled]="!file()" (click)="download()">
    {{ 'documentEditor.download' | translate }}
  </button>
</mat-dialog-actions>
